import React from "react";
import { DatePicker } from "antd";
import { useSelector, useDispatch } from "react-redux";
import dayjs from "dayjs";
import { updateDisplayDate } from "../../../reducer/bookingReducer";

const ArrivalAndDurationDate = ({
  customerData,
  handleCustomerDataFieldChange,
}) => {
  const dispatch = useDispatch();

  const { displayDate } = useSelector((store) => store.booking);

  const handleDateChange = (date, dateString, field) => {
    handleCustomerDataFieldChange("grcDetails", {
      ...customerData?.grcDetails,
      [field]: date,
    });
    dispatch(updateDisplayDate(null));
  };

  return (
    <div className="flex justify-between items-center gap-[24px]">
      <div className="flex flex-col gap-[6px] w-[55%]">
        <div className="text-[#222B45] text-[14px]">Date of Arrival</div>
        <div
          className="flex  items-center rounded-[12px] border-[1px] border-[#EDF1F7]  relative w-[100%] "
          onClick={(e) => {
            dispatch(
              updateDisplayDate(displayDate === "arrival" ? null : "arrival")
            );
            e.stopPropagation();
          }}
        >
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <DatePicker
              allowClear={false}
              onChange={(date, dateString) =>
                handleDateChange(date, dateString, "dateOfArrival")
              }
              value={customerData?.grcDetails?.dateOfArrival ?? ""}
              style={{
                borxder: "none",
                width: "0",
                height: "0",
                padding: "0",
                display: "hidden",
              }}
              suffixIcon={<></>}
              format={"YYYY/MM/DD"}
              open={displayDate === "arrival"}
              placement="bottomLeft"
              size="small"
            />
          </div>

          <div className="flex  cursor-pointer w-[100%]">
            <span className="p-2  pl-4 px-2 font-outfit  text-[6px]  md:text-[10px] lg:text-[12px] text-[#4D4D4D] font-[400] ">
              {customerData?.grcDetails?.dateOfArrival
                ? dayjs(customerData?.grcDetails?.dateOfArrival).format(
                    "D/MM/YYYY"
                  )
                : dayjs().format("D/MM/YYYY")}
            </span>
          </div>
        </div>{" "}
      </div>

      <div className="flex flex-col gap-[6px] w-[50%]">
        <div className="text-[#222B45] text-[14px]">Date of Departure</div>
        <div
          className="flex  items-center rounded-[12px] border-[1px] border-[#EDF1F7]  relative w-[100%] "
          onClick={(e) => {
            dispatch(updateDisplayDate(displayDate === "dod" ? null : "dod"));
            e.stopPropagation();
          }}
        >
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <DatePicker
              allowClear={false}
              onChange={(date, dateString) =>
                handleDateChange(date, dateString, "dateOfDeparture")
              }
              value={customerData?.grcDetails?.dateOfDeparture ?? ""}
              style={{
                borxder: "none",
                width: "0",
                height: "0",
                padding: "0",
                display: "hidden",
              }}
              suffixIcon={<></>}
              format={"YYYY/MM/DD"}
              open={displayDate === "dod"}
              placement="bottomLeft"
              size="small"
            />
          </div>

          <div className="flex  cursor-pointer w-[100%]">
            <span className="p-2  pl-4 px-2 font-outfit  text-[6px]  md:text-[10px] lg:text-[12px] text-[#4D4D4D] font-[400] ">
              {customerData?.grcDetails?.dateOfDeparture
                ? dayjs(customerData?.grcDetails?.dateOfDeparture)?.format(
                    "D/MM/YYYY"
                  )
                : dayjs().format("D/MM/YYYY")}
            </span>
          </div>
        </div>{" "}
      </div>
    </div>
  );
};

export default ArrivalAndDurationDate;
